<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781466824409_toc01#toctitle1" id="title1"><span><strong class="b">ACKNOWLEDGMENTS</strong></span></a></div>
<div class="p"><span>This book owes a large debt to my husband, Charles Sheffield, who graciously loaned me the McAndrew Drive, originally created by his character Arthur Morton McAndrew, with the proviso that when I was done with the drive, I return it cleaned and in good condition. Thank you, Charles and Arthur.</span></div>
<div class="p-indent"><span>I would also like to thank my editor, Jim Minz, for his many valuable suggestions for revision.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466824409_ack01.vue?6231597e